// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-79e09e44]{background:#78a6b8;height:32px;width:100%;display:flex;flex-direction:row;justify-content:center;align-items:center}.text[data-v-79e09e44]{font-size:12px;line-height:18px;color:#000;margin-left:1px;margin-right:1px}.tz-name[data-v-79e09e44]{font-weight:700}.change-it[data-v-79e09e44]{font-size:12px;line-height:18px;margin-left:2px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
